/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddUserToSiteInput } from '../models/AddUserToSiteInput';
import type { CreatePatientData } from '../models/CreatePatientData';
import type { CreatePDFInput } from '../models/CreatePDFInput';
import type { CurrentOwnerUpdateInput } from '../models/CurrentOwnerUpdateInput';
import type { FitStationMedicalProfile } from '../models/FitStationMedicalProfile';
import type { FitStationMedicalSolutionDataInput } from '../models/FitStationMedicalSolutionDataInput';
import type { FitStationProfile } from '../models/FitStationProfile';
import type { FitStationSolutionDataInput } from '../models/FitStationSolutionDataInput';
import type { Patient } from '../models/Patient';
import type { PatientData } from '../models/PatientData';
import type { PatientPage } from '../models/PatientPage';
import type { PDFModel } from '../models/PDFModel';
import type { Session } from '../models/Session';
import type { SessionInput } from '../models/SessionInput';
import type { SessionStatusEnum } from '../models/SessionStatusEnum';
import type { User } from '../models/User';
import type { UserInput } from '../models/UserInput';
import type { UserRecordInput } from '../models/UserRecordInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfileService {
    /**
     * Create a new user.
     * Create a new user.
     * @param requestBody
     * @returns User The created user.
     * @throws ApiError
     */
    public static profileControllerCreateUserRecord(
        requestBody: UserRecordInput,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/user/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get user by ID.
     * Get user by ID.
     * @param userId
     * @returns User The requested user.
     * @throws ApiError
     */
    public static profileControllerUser(
        userId: string,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/user/{userID}',
            path: {
                'userID': userId,
            },
            errors: {
                404: `User not found.`,
            },
        });
    }
    /**
     * @param userId
     * @returns boolean
     * @throws ApiError
     */
    public static profileControllerCanDeleteUser(
        userId: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/user/{userID}/canDelete',
            path: {
                'userID': userId,
            },
        });
    }
    /**
     * Get a Patient
     * Retrieve a patient by ID.
     * @param patientId
     * @returns Patient The requested patient.
     * @throws ApiError
     */
    public static profileControllerGetPatient(
        patientId: string,
    ): CancelablePromise<Patient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/patient/{patientID}',
            path: {
                'patientID': patientId,
            },
            errors: {
                404: `Patient not found`,
                500: `Error while communicating with DB.`,
            },
        });
    }
    /**
     * Query a list of patients.
     * Query a list of patients filtered by query parameters.
     * @param storeId
     * @param companyId
     * @param sessionStatuses
     * @param offset
     * @param limit
     * @returns PatientPage The requested patients.
     * @throws ApiError
     */
    public static profileControllerGetPatients(
        storeId: string,
        companyId?: string,
        sessionStatuses?: Array<SessionStatusEnum>,
        offset?: number,
        limit?: number,
    ): CancelablePromise<PatientPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/patients/{storeID}',
            path: {
                'storeID': storeId,
            },
            query: {
                'companyID': companyId,
                'sessionStatuses': sessionStatuses,
                'offset': offset,
                'limit': limit,
            },
        });
    }
    /**
     * Create a new session.
     * Create a new session.
     * @param requestBody
     * @returns Session The created session.
     * @throws ApiError
     */
    public static profileControllerCreateSession(
        requestBody: SessionInput,
    ): CancelablePromise<Session> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/session/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a session.
     * Retrieve a session by ID.
     * @param sessionId
     * @returns Session The requested session.
     * @throws ApiError
     */
    public static profileControllerSession(
        sessionId: string,
    ): CancelablePromise<Session> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/session/{sessionID}',
            path: {
                'sessionID': sessionId,
            },
            errors: {
                404: `Session not found.`,
            },
        });
    }
    /**
     * Delete a user.
     * Delete a user by ID.
     * @param userId
     * @returns boolean
     * @throws ApiError
     */
    public static profileControllerDeleteUser(
        userId: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/profile/user/{userID}/delete',
            path: {
                'userID': userId,
            },
        });
    }
    /**
     * Update an existing user.
     * Update an existing user by ID.
     * @param userId
     * @param requestBody
     * @returns User The updated user.
     * @throws ApiError
     */
    public static profileControllerUpdateUser(
        userId: string,
        requestBody: UserInput,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/user/{userID}/update',
            path: {
                'userID': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Failed to update user.`,
            },
        });
    }
    /**
     * Update current owner.
     * Update current owner by userID.
     * @param requestBody
     * @returns User The updated user.
     * @throws ApiError
     */
    public static profileControllerUpdateCurrentOwner(
        requestBody: CurrentOwnerUpdateInput,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/update/currentOwner',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `User not found.`,
            },
        });
    }
    /**
     * Update FitStation profile of an existing user.
     * Update FitStation profile of an existing user.
     * @param userId
     * @param requestBody
     * @returns FitStationProfile The updated FitStation profile.
     * @throws ApiError
     */
    public static profileControllerUpdateFitStationProfile(
        userId: string,
        requestBody: FitStationSolutionDataInput,
    ): CancelablePromise<FitStationProfile> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/{userID}/update/fitStationProfile',
            path: {
                'userID': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Failed to update FitStation profile.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Get an existing FitStation profile.
     * Get a FitStation profile by userID.
     * @param userId
     * @returns FitStationProfile The requested FitStation profile.
     * @throws ApiError
     */
    public static profileControllerFitStationProfile(
        userId: string,
    ): CancelablePromise<FitStationProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/user/{userID}/fitStationProfile',
            path: {
                'userID': userId,
            },
            errors: {
                404: `User not found.`,
            },
        });
    }
    /**
     * Update an existing FitStation medical profile.
     * Update a FitStation medical profile.
     * @param userId
     * @param requestBody
     * @param action
     * @param sessionId
     * @param update
     * @returns FitStationMedicalProfile The updated FitStation medical profile.
     * @throws ApiError
     */
    public static profileControllerUpdateFitStationMedicalProfile(
        userId: string,
        requestBody: FitStationMedicalSolutionDataInput,
        action?: SessionStatusEnum,
        sessionId?: string,
        update?: boolean,
    ): CancelablePromise<FitStationMedicalProfile> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/{userID}/update/fitStationMedicalProfile',
            path: {
                'userID': userId,
            },
            query: {
                'action': action,
                'sessionID': sessionId,
                'update': update,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `User not found.`,
            },
        });
    }
    /**
     * Get an existing FitStation medical profile.
     * Get a FitStation medical profile by userID.
     * @param userId
     * @returns FitStationMedicalProfile The requested FitStation medical profile.
     * @throws ApiError
     */
    public static profileControllerFitStationMedicalProfile(
        userId: string,
    ): CancelablePromise<FitStationMedicalProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/profile/user/{userID}/fitStationMedicalProfile',
            path: {
                'userID': userId,
            },
            errors: {
                404: `User not found.`,
            },
        });
    }
    /**
     * Generate a PDF data model.
     * Generate a PDF data model from input.
     * @param requestBody
     * @returns PDFModel The generated PDF data model.
     * @throws ApiError
     */
    public static profileControllerCreatePdf(
        requestBody: CreatePDFInput,
    ): CancelablePromise<PDFModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/create/PDFInput',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create patient
     * This endpoint create a patient and upload scans.
     * @param createPatientData
     * @param requestBody
     * @returns PatientData The requested Patient.
     * @throws ApiError
     */
    public static profileControllerCreatePatient(
        createPatientData: any,
        requestBody: CreatePatientData,
    ): CancelablePromise<PatientData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/patient/{createPatientData}/create',
            path: {
                'createPatientData': createPatientData,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `NotFound`,
                422: `Some of provided data are invalid due to defined schema.`,
                500: `Error while communicating with DB.`,
            },
        });
    }
    /**
     * Assign an existing user to a store/site.
     * Assign an existing user to a store/site.
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    public static profileControllerAddUserToSite(
        requestBody: AddUserToSiteInput,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/addUserToSite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Copy existing FitStation medical profile.
     * Copy a FitStation medical profile.
     * @param userId
     * @param oldUserId
     * @param sessionId
     * @param oldSessionId
     * @returns FitStationMedicalProfile The copied FitStation medical profile.
     * @returns FitStationProfile
     * @throws ApiError
     */
    public static profileControllerCopyFitStationProfile(
        userId: string,
        oldUserId: string,
        sessionId: string,
        oldSessionId: string,
    ): CancelablePromise<FitStationMedicalProfile | FitStationProfile> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/profile/{userID}/copyFitStationProfile',
            path: {
                'userID': userId,
            },
            query: {
                'oldUserID': oldUserId,
                'sessionID': sessionId,
                'oldSessionID': oldSessionId,
            },
            errors: {
                404: `User not found.`,
            },
        });
    }
}
